import { useForm } from "react-hook-form";
import { LightRoutingLink, PrimaryButton } from "../../../../components/buttons/buttons";
import PasswordControl from "../../../../components/controls/password-control/password-control";
import TextControl from "../../../../components/controls/text-control/text-control";
import { Credentials } from "../../../../core/providers/authentication-provider";
import useOnce from "../../../../hooks/use-once";
import { useRouting } from "../../../../hooks/with-routing";
import { ActionHandler } from "../../../../types";

export type FormaLogin = Omit<Credentials, "segment">;

type LoginFormProps = {
	loading?: boolean;
	onSignIn: ActionHandler<FormaLogin>;
};

const LoginForm = ({ loading, onSignIn }: LoginFormProps) => {
	const methods = useForm<FormaLogin>();
	const createPath = useRouting.use.createPath();
	const imageUrl = createPath("/Usuarios/Configuracion/:segmento/Logo");

	const signInHandler = (form: FormaLogin) => {
		onSignIn(form);
	};

	useOnce(() => {
		methods.setFocus("username");
	});

	return (
		<form>
			<div className="card-login-title">
				<img src={imageUrl} alt="alt" height="45px" />
				<div className="col-12">
					<span className="text-uppercase">INICIA SESIÓN</span>
				</div>
			</div>
			<div className="mb-3">
				<TextControl
					name="username"
					label="Usuario"
					maxLength={15}
					formMethods={methods}
					pattern={{
						message: "Sólo permite letras, números y algunos caracteres especiales ( & # * - _ )",
						value: /^([A-Z0-9&#*\-_]{8,15})$/i
					}}
					minLength={{
						message: "La longitud debe ser entre 8 y 15 caracteres",
						value: 8
					}}
					required
				/>
			</div>
			<div className="mb-3">
				<PasswordControl
					name="code"
					label="Contraseña"
					maxLength={25}
					formMethods={methods}
					pattern={{
						message: "Sólo permite letras, números y algunos caracteres especiales ( @ # $ % & ! * )",
						value: /^([A-Z0-9@#$%&!*]{12,25})$/i
					}}
					minLength={{
						message: "La longitud debe ser entre 12 y 25 caracteres",
						value: 12
					}}
					required
				/>
			</div>
			<div className="mb-3 text-center">
				<LightRoutingLink className="link-banorte" disabled={loading} to="/:segmento/restablecer-clave">¿Olvidaste tu contraseña?</LightRoutingLink>
			</div>
			<div className="mb-3 d-grid">
				<PrimaryButton disabled={loading} onClick={methods.handleSubmit(signInHandler)}>Entrar</PrimaryButton>
			</div>
			<div className="mb-3 text-center">
				<LightRoutingLink className="link-banorte" disabled={loading} to="/:segmento/registrarse">Registrar nueva cuenta</LightRoutingLink>
			</div>
			<div className="mb-3 aviso">
				<p>Los datos personales serán tratados en apego al aviso de privacidad de Banorte disponible de forma permanente en <a target="_blank" rel="noreferrer" href="https://www.banorte.com">www.banorte.com</a>.</p>
			</div>
		</form>
	)
};

export default LoginForm;